// https://stackoverflow.com/questions/19262141/resize-image-with-javascript-canvas-smoothly
// https://stackoverflow.com/questions/38896824/canvas-on-resize-keep-a-maximal-width-or-height-without-stretching-padding
// https://stackoverflow.com/questions/10652513/html5-dynamically-create-canvas

const getScale = (type, { width, height, max_width, max_height }) => {
  if (type === "fit") {
    return Math.min(max_width / width, max_height / height);
  }
  if (type === "fill") {
    return Math.max(max_width / width, max_height / height);
  }
}


// resize preserving ratio to max_width, max_height
export default function resizeImage(src, max_width, max_height, cb) {
  var canvas = document.createElement('canvas');
  canvas.width = max_width;
  canvas.height = max_height;

  var ctx = canvas.getContext("2d");
  var img = new Image();

  img.onload = function () {
    const scale = getScale("fit", {width: img.width, height: img.height, max_width, max_height});

    // get the top left position of the image
    var x = (canvas.width / 2) - (img.width / 2) * scale;
    var y = (canvas.height / 2) - (img.height / 2) * scale;
    ctx.drawImage(img, x, y, img.width * scale, img.height * scale);

    const data_url = canvas.toDataURL();

    cb(data_url);
  }

  img.src = src
}
